import React from "react";
import CustomPopoverMui from "../../../../CustomPopoverMui/CustomPopoverMui";
import {
  Box,
  ListItemIcon,
  ListItemText,
  makeStyles,
  MenuItem,
} from "@material-ui/core";
import { Check } from "lucide-react";

const conversionTypesOptions = [
  {
    label: "Docx - PDF",
    accept: ".docx",
    extension: "pdf",
  },
  {
    label: "PDF - Xlsx",
    accept: ".pdf",
    extension: "xlsx",
  },
  {
    label: "PDF - CSV",
    accept: ".pdf",
    extension: "csv",
  },
];

const useStyles = makeStyles({
  listItemIcon: {
    minWidth: "25px",
  },
});

const ConversionTypePopover = (props) => {
  const {
    anchorEl,
    handleClose,
    id,
    conversionType,
    open,
    handleConversionTypeSelect,
  } = props;
  const classes = useStyles();

  return (
    <CustomPopoverMui
      anchorEl={anchorEl}
      handleClose={handleClose}
      open={open}
      id={id}
    >
      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",

          width: "100%",
          padding: "0.5rem",
        }}
      >
        {conversionTypesOptions.map((type) => (
          <MenuItem
            key={type.label}
            onClick={() => {
              handleClose();
              handleConversionTypeSelect(type);
            }}
            style={{
              backgroundColor:
                type.label === conversionType?.label
                  ? "#f0f5f0"
                  : "transparent",
              borderRadius: "8px",
              padding: "2px 16px",
            }}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <Check
                className="w-5 h-5"
                color={
                  type.label === conversionType?.label ? "#000000DE" : "white"
                }
              />
            </ListItemIcon>
            <ListItemText primary={type.label} />
          </MenuItem>
        ))}
      </Box>
    </CustomPopoverMui>
  );
};

export default ConversionTypePopover;
